<template>
  <q-bar class="bg-white">
    <q-btn dense flat round :to="{ name: 'AccountIndex' }">
      <i class="fas fa-chevron-left"></i>
    </q-btn>
    <div class="col text-center">{{ $t('account.importReservation') }}</div>
  </q-bar>
  <q-form ref="form" class="q-ma-md">
    <q-input
      v-model="form.serno"
      outlined
      type="text"
      bg-color="white"
      :label="`${$t('importReservation.serno')} *`"
      :rules="sernoRules"
    />
    <!-- <q-input
      v-model="form.password"
      outlined
      type="text"
      bg-color="white"
      :label="`${$t('generic.text.password')} *`"
      :rules="passwordRules"
    /> -->
    <q-btn
      class="full-width q-mt-md"
      color="primary"
      :label="$t('generic.text.submit')"
      @click="onSubmit"
    />
    <q-btn
      class="full-width q-mt-md"
      color="primary"
      :label="$t('qrCodeScanner.title')"
      @click="dialog = true"
    />
  </q-form>

  <q-dialog v-model="dialog" persistent maximized>
    <q-card class="bg-white">
      <q-bar>
        <q-space />
        <q-btn v-close-popup dense flat icon="fas fa-times" />
      </q-bar>
      <qrcode-scanner @decode="onDecode" />
    </q-card>
  </q-dialog>
</template>

<script>
import QrcodeScanner from '@/components/QRCodeScanner.vue';
import { mapActions, mapState } from 'vuex';

export default {
  components: {
    QrcodeScanner,
  },
  data() {
    return {
      dialog: false,
      decode: {},
      query: {},
      form: {
        serno: '',
        fromId: '',
        toId: '',
      },
      sernoRules: [
        (v) =>
          !!v ||
          this.$t('generic.error.required', {
            msg: this.$t('importReservation.serno'),
          }),
      ],
      passwordRules: [
        (v) =>
          !!v ||
          this.$t('generic.error.required', {
            msg: this.$t('personalInfo.password'),
          }),
      ],
    };
  },
  computed: {
    ...mapState({
      personalInfo: (state) => state.user.personalInfo,
    }),
  },
  created() {
    this.query = this.$route.query;
    this.form.serno = this.query?.serno || '';
    this.form.fromId = this.query?.fromId || '';
    this.form.toId = this.personalInfo.userid;
    console.log(this.form);
  },
  methods: {
    ...mapActions({
      importTrade: 'trade/importTrade',
      getTradeById: 'trade/getTradeById',
    }),

    onDecode(data) {
      const obj = JSON.parse(data);
      this.form.serno = obj.serno;
      this.form.fromId = obj.fromId;
      this.dialog = false;
    },
    onSubmit() {
      this.$refs.form.validate().then((success) => {
        if (!success) return;

        this.getTradeById(this.form.serno)
          .then(() => {
            this.importTrade({
              orderId: this.form.serno,
              fromId: this.form.fromId,
              toId: this.form.toId,
            })
              .then(() => {
                this.$notify.create({
                  message: this.$t('importReservation.success'),
                  position: 'top',
                  type: 'positive',
                });
              })
              .catch((err) => {
                console.log(err);

                this.$notify.create({
                  type: 'negative',
                  position: 'top',
                  message: this.$t('importReservation.failed'),
                  caption: err.response.data,
                });
              });

            console.log(this.form);
          })
          .catch((err) => {
            console.log(err);

            this.$notify.create({
              message: this.$t('trade.notFound'),
              position: 'top',
              type: 'negative',
            });
          });
      });
    },
  },
};
</script>
